import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("button__buttonstyles-1kt9nt", {
  cursor: "pointer",
  appearance: "none",
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  userSelect: "none",
  whiteSpace: "nowrap",
  verticalAlign: "middle",
  outlineOffset: "2px",
  width: "auto",
  transition: "opacity 0.3s",
  lineHeight: "1.2",
  "&[disabled]": {
    cursor: "not-allowed"
  }
});
import React from 'react';
import Spinner from '../spinner';

/**
 * Re-usable screen-reader friendly Button component.
 * @alias ButtonProps
 * */
export interface ButtonProps extends HtmlProps<HTMLButtonElement> {
  /**
  * Shows a spinner and disables the button, for when there is a loading action happening.
  *  * Default is false.
  *  * */
  loading?: boolean;
  /**
  * * The type of the button.
  *  * */
  type?: 'submit' | 'button' | 'reset';
  className?: string;
  children?: React.ReactNode | string;
  disabled?: boolean;
  style?: React.CSSProperties;
}
export const buttonStyles = _staticStyles;
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({
  disabled,
  style,
  loading,
  className,
  children,
  type = 'button',
  ...props
}, ref) => <button
/* eslint-disable-next-line react/button-has-type */ {..._mergeProps({
  type: type,
  ref: ref,
  "aria-disabled": disabled,
  disabled: disabled || loading,
  style: style,
  className: className,
  "aria-pressed": loading !== undefined ? loading : undefined,
  css: buttonStyles
}, props)}>
            <div aria-hidden={!loading} className="button__div-37s9ag" style={{
    "--static-styles-0wmgiset_opacity": loading ? 1 : 0
  }}>
                <Spinner size="sm" />
            </div>
            <span aria-hidden={!!loading} className="button__span-3eeezr" style={{
    "--static-styles-29jwl4ti_opacity": loading ? 0 : 1
  }}>
                {children}
            </span>
        </button>);
Button.displayName = 'Button';
export default Button;